var map = {
	"./BLUE_YONDER_RETURNS_PORTAL.json": [
		2201,
		2201
	],
	"./BPOST_RETURNS_PORTAL.json": [
		25945,
		5945
	],
	"./DPD_UK_RETURNS_PORTAL.json": [
		51861,
		1861
	],
	"./GLS_ES_RETURNS_PORTAL.json": [
		30225,
		225
	],
	"./RETURNS_PORTAL.json": [
		49729,
		9729
	],
	"./SINGAPORE_POST_RETURNS_PORTAL.json": [
		91625,
		1625
	],
	"./STARLINKS_RETURNS_PORTAL.json": [
		19538,
		9538
	],
	"./USPS_RETURNS_PORTAL.json": [
		19886,
		9886
	],
	"./YAMATO_RETURNS_PORTAL.json": [
		55665,
		5665
	],
	"./international/RETURNS_PORTAL.json": [
		71334,
		1334
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 71093;
module.exports = webpackAsyncContext;